<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/extra.webp"
  >
    <ng-container i18n
      >Extras are additional services or products added to a booking, like cleaning or amenities. Actions include
      notifying guests when extras are created or paid for and informing property managers or hosts. This entity ensures
      the smooth handling of supplementary services beyond the basic booking.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when an extra is</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.ExtraCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ExtraCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Created
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.ExtraPaid)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ExtraPaid ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Marked as Paid
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.ExtraDeleted)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ExtraDeleted ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Deleted
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.ExtraCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
        <ng-template *ngSwitchCase="events.ExtraPaid" [ngTemplateOutlet]="paidEvent"></ng-template>
        <ng-template *ngSwitchCase="events.ExtraDeleted" [ngTemplateOutlet]="deletedEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
      <app-automation-channel-rental-select
        [form]="form"
        [allowsChannel]="false"
      ></app-automation-channel-rental-select>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Extra is Created</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Extra is Marked as Paid</h6>
    <ng-template [ngTemplateOutlet]="paidEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Extra is Deleted</h6>
    <ng-template [ngTemplateOutlet]="deletedEvent"></ng-template>
  </div>
</div>

<ng-template #createdEvent>
  <app-notify-handler-automation
    [event]="events.ExtraCreated"
    [handler]="eventHandlers.ExtraNotifyGuestHandler"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the guest"
    name="Notify the guest of the extra created"
    [messageSubject]="guestNotificationMessages[events.ExtraCreated].subject"
    [messageBody]="guestNotificationMessages[events.ExtraCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
    [filterByCategories]="true"
    [categories]="categories$ | async"
  >
  </app-notify-handler-automation>

  <app-notify-users-automation
    [event]="events.ExtraCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of extra created"
    [messageSubject]="userNotificationMessages[events.ExtraCreated].subject"
    [messageBody]="userNotificationMessages[events.ExtraCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #paidEvent>
  <app-notify-users-automation
    [event]="events.ExtraPaid"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of extra paid"
    [messageSubject]="userNotificationMessages[events.ExtraPaid].subject"
    [messageBody]="userNotificationMessages[events.ExtraPaid].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #deletedEvent>
  <app-notify-users-automation
    [event]="events.ExtraDeleted"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of extra deleted"
    [messageSubject]="userNotificationMessages[events.ExtraDeleted].subject"
    [messageBody]="userNotificationMessages[events.ExtraDeleted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>
